<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      <v-row>
        <v-col cols="2">
          <v-icon left>{{ icon }}</v-icon></v-col
        >
        <v-col cols="8"> {{ text }}</v-col>
        <v-col cols="2">
          <v-icon @click="snackbar = false">{{ closeIcon }}</v-icon></v-col
        >
      </v-row>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'toaster',
  data: () => ({
    snackbar: false,
    mode: '',
    color: '',
    icon: null,
    closeIcon: 'mdi-close',
    text: ''
  }),
  props: {
    successTimeout: {
      type: Number,
      default: 2000
    },

    timeout: {
      type: Number,
      default: 6000
    }
  },
  methods: {
    pop: function (status, message) {
      switch (status.toLowerCase()) {
        case 'error':
          this.color = 'error'
          this.icon = 'mdi-alert-outline'
          break
        case 'success':
          this.color = 'success'
          this.icon = 'mdi-check-circle-outline'
          break
        case 'info':
          this.color = 'accent'
          this.icon = 'mdi-information-outline'
          break
      }
      this.text = message
      this.snackbar = true
    }
  }
}
</script>

<style scoped></style>
